
import type { LanguageStrings } from '@/language/types'
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'MembersOnly' })
export default class extends Vue {
  t: LanguageStrings['membersOnly']
}
